import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${API_BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Global 401 interceptor — redirect to /login for protected pages
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const url = err.config?.url || "";
      // Never redirect on /auth/me — that's the anonymous session check
      if (!url.includes("/auth/me") && !url.includes("/auth/refresh")) {
        const p = window.location.pathname;
        const publicPrefixes = ["/property/"];
        const publicExact = ["/", "/marketplace", "/secondary", "/calculator", "/about", "/contact", "/faq", "/terms", "/privacy", "/risk", "/how-it-works", "/login", "/register", "/forgot-password", "/reset-password", "/payment/cancel"];
        const isPublic = publicExact.includes(p) || publicPrefixes.some((x) => p.startsWith(x));
        if (!isPublic && p !== "/login") {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export function money(v, currency = "INR") {
  const n = Number(v || 0);
  const cur = (currency || "INR").toUpperCase();
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency", currency: cur,
      maximumFractionDigits: cur === "INR" ? 0 : 0,
    }).format(n);
  } catch {
    return `${cur} ${n.toLocaleString()}`;
  }
}

export const CURRENCY_SYMBOLS = { USD: "$", EUR: "€", AUD: "A$", CAD: "C$", INR: "₹" };
export const SUPPORTED_CURRENCIES = ["USD", "EUR", "AUD", "CAD", "INR"];

export function pct(v, digits = 2) {
  return `${Number(v || 0).toFixed(digits)}%`;
}
